import AnimatedCounter from "./AnimatedCounter";
import AnimateOnScroll from "./AnimateOnScroll";

const stats = [
  { value: "+34%", label: "Avg. conversion lift" },
  { value: "24/7", label: "Autonomous optimization" },
  { value: "5min", label: "Setup time" },
  { value: "0", label: "Code required" },
];

const Stats = () => {
  return (
    <section className="py-20 bg-foreground relative overflow-hidden">
      {/* Subtle animated dot pattern */}
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage: "radial-gradient(circle, hsl(var(--background)) 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <AnimateOnScroll key={index} delay={index * 150}>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-semibold text-background mb-2">
                  <AnimatedCounter value={stat.value} />
                </div>
                <div className="text-sm text-background/60">
                  {stat.label}
                </div>
              </div>
            </AnimateOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
